import styled from '@emotion/styled';
import { CheckmarkIcon } from '../Icons/newIcons/CheckmarkIcon';

export const CheckmarkList = styled.ul`
    display: flex;
    width: 100%;
    clear: both;
    flex-flow: column wrap;
    margin-bottom: 24px;
`;

export const CheckmarkListItem = styled.li`
    color: ${({ theme }) => theme.text.color.primary};
    font-size: 14px;
    line-height: 22px;
    display: flex;
    & > * {
        flex-shrink: 0;
    }
    &:not(:first-child) {
        margin-top: 8px;
    }
`;

export const CheckmarkListItemIcon = styled(CheckmarkIcon)`
    width: 15px;
    height: 20px;
    fill: ${({ theme }) => theme.icon.brandColor2};
`;

export const CheckmarkListItemText = styled.span`
    margin: 0 0 0 8px;
    max-width: 100%;
`;
